/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import { pieProtectSPI, ENCRYPTION_INPUT } from '@vz-react/pie-encryption';
import * as Actions from './actions';
// import * as getCheckoutActions from '../FuncComp/actions.js';
import * as Constants from './Constants';
import * as cartActions from '../../services/Cart/actions';
import * as ShippingActions from '../ShippingInfo/actions';
import * as actionTypes from '../../components/NextGen/ExpressCheckout/@Redux/actionTypes.js';
import { logError } from '../../services/loggerService';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import {
  getAPPID,
  getSession,
  isFuncComp,
  isPreorder,
  isSequentialFlow,
  getServiceUrlandE2eRequestId,
  cartContactInfoIntg,
  setSession,
  isExpressCheckout,
} from '../../components/common/Helpers';
import { updateToAEP } from '../../components/common/Tagging/index';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { store } from '../../configureStore';
import * as CreditCheckActions from '../CreditCheck/actions';
import * as CreditCheckConstants from '../CreditCheck/Constants';

function* getContactInfoFromApi({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(Actions.getContactInfoData, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_CONTACT_INFO_SUCCESS, response: apiResponse.data });
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getContactInfoFromApi ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getContactInfoOnClick({ data, homePhoneAdded }) {
  try {
    yield put(notificationActions.hideNotification());

    let isSuccess = true;

    // // handle PIE encryption
    const encPinNumber = yield call(pieProtectSPI, data.accountPin, ENCRYPTION_INPUT.PIN);

    isSuccess = encPinNumber?.encryptionStatus?.isSuccess;
    if (!isSuccess) {
      // encryption failed - unable to load encrypted pin info
      const errorMsg = Constants.DEFAULT_ERR_MSG;
      yield put(notificationActions.showErrorNotification(errorMsg));
      return;
    }
    const contactInfoData = {
      accountPin: encPinNumber.encryptedData,
      billingAddress: data && data.billingAddress,
      accountNumber: data && data.cartDetails && data.cartDetails.accountNumber ? data.cartDetails.accountNumber : '',
      cartCreator: data && data.cartDetails && data.cartDetails.cartCreator ? data.cartDetails.cartCreator : '',
      receiveSpecialOfferUpdates: data && data.receiveSpecialOfferUpdates,
    };
    if (data.currentEmail !== data.previousEmail) {
      yield put({ type: Constants.TOGGLE_UNIVERSAL_PROFILE_BANNER_DISPLAYED });
      yield put({ type: Constants.CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE });
    }
    yield put({ type: Constants.STORE_PREVIOUS_EMAIL, payload: data.currentEmail });
    contactInfoData.isCradleSuccess = data.isCradleSuccess;
    if (data.isCradleSuccess) {
      contactInfoData.password = data?.password;
      contactInfoData.isUniversalProfileCreated = data?.isUniversalProfileCreated;
      contactInfoData.isEmailExists = data.isEmailExists;
      contactInfoData.password = data.password;
    }

    yield call(postNSEContactInfoData, contactInfoData, homePhoneAdded, data.isSelfSetup);
  } catch (error) {
    console.log(error);
  } finally {
    yield put({ type: Constants.UNIVERSAL_PROFILE_BANNER_MESSAGES, payload: data.universalProfileCreationBannerMessages });
  }
}

function* postNSEContactInfoData(data, homePhoneAdded, isSelfSetup) {
  const notifyErrorMessage = data.notifyMessage;
  yield put(notificationActions.hideNotification());
  let updatePersonalError = false;
  let contactInfoInvalidCaseError = false;
  let serviceDetails = null;
  yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError });
  yield put({ type: Constants.CI_INVALID_CASE_ERROR, response: contactInfoInvalidCaseError });
  yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: updatePersonalError, errorMessage: null });
  try {
    showLoader();
    const apiResponse = yield call(Actions.postNSEContactInfoDataAPI, data, homePhoneAdded);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse?.data?.serviceHeader?.statusCode === '00') {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        if (apiResponse?.data?.serviceBody?.serviceResponse?.context?.amProfileCreationResponse && data.isCradleSuccess)
          yield call(createUniversalProfile, apiResponse?.data?.serviceBody?.serviceResponse?.context?.amProfileCreationResponse);
        // yield call(cartActions.getCartDetails, { pageName: data });
        yield put({ type: 'POST_NSE_DATA_RESPONSE', response: apiResponse.data });
        yield put({ type: Constants.IS_UPDATE_INFO_SUCCESS, response: true });
        updateToAEP(data?.billingAddress?.email, data?.billingAddress?.phoneNumber);

        if (isSelfSetup && getAPPID() === 'AAL') {
          const response = yield call(Actions.updateISPUContactInfo, data, homePhoneAdded);
          if (response && response.data) {
            yield put({ type: 'IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS', response: true });
            if (
              response.data.serviceHeader &&
              ((response.data.serviceHeader.statusMsg && response.data.serviceHeader.statusMsg === 'SUCCESS') ||
                (response.data.serviceHeader.statusCode && response.data.serviceHeader.statusCode === '00'))
            ) {
              yield put({ type: 'UPDATE_CONTACT_SUCCESS', response: response.data });
            }
          }
        }
      }
      yield call(Actions.postPushMessageAPI, data);
      hideLoader();
    } else {
      if (apiResponse.data.errors[0] && apiResponse.data.errors[0].name === 'ADDRESS_VALIDATION_ERROR') {
        yield put({ type: 'BILLING_ADDRESS1_ERROR', response: true });
      }
      if (apiResponse && apiResponse?.status === 400 && apiResponse?.data?.errors) {
        if (checkInvalidCaseCartError(apiResponse?.data?.errors)) {
          contactInfoInvalidCaseError = true;
          yield put({
            type: Constants.CEF_CONTACT_INFO_ERROR,
            response: contactInfoInvalidCaseError,
            errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
          });
        }
      } else if (apiResponse?.data?.errors || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
        updatePersonalError = true;
        yield put({
          type: Constants.CEF_CONTACT_INFO_ERROR,
          response: updatePersonalError,
          errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
        });
      }
      serviceDetails = {
        serviceUrl: apiResponse?.config?.url,
        method: 'postNSEContactInfoData',
        e2eid: apiResponse?.headers?.e2erequestid,
      };
      yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CI_INVALID_CASE_ERROR, response: contactInfoInvalidCaseError, serviceinfo: serviceDetails });
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));

      if (apiResponse?.data?.errors || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `postNSEContactInfoData ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        hideLoader();
      }
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    if (error) {
      updatePersonalError = true;
      serviceDetails = {
        method: 'postNSEContactInfoData',
      };
      yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: updatePersonalError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
}

function* postContactInfo({ data, homePhoneAdded, creditCheckRequest, installType }) {
  let updatePersonalError = false;
  let contactInfoInvalidCaseError = false;
  let serviceDetails = null;
  yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError });
  yield put({ type: Constants.CI_INVALID_CASE_ERROR, response: contactInfoInvalidCaseError });
  yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: updatePersonalError, errorMessage: null });
  try {
    showLoader();
    yield put(notificationActions.hideNotification());
    const apiResponse = yield call(Actions.postContactInfoData, data, homePhoneAdded);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse?.data?.serviceHeader?.statusCode === '00') {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        updateToAEP(data?.param[0]?.email, data?.param[0]?.phoneNumber);
        yield put({ type: Constants.POST_DATA_SUCCESS, response: apiResponse.data });
        // yield put({ type: Constants.CONTACT_INFO_EDIT_RESPONSE, data: 'success' });
        yield put({ type: Constants.CONTACT_INFO_EDIT_ERROR, data: '' });
        if (getAPPID() === 'AAL' || isSequentialFlow()) {
          yield put({ type: 'UPDATE_CONTACT_INFO_COMPLETED', data: 'true' });
        }
        if (isSequentialFlow() && data?.param[0]?.address) {
          setSession('isSeqUPICompleted', 'true');
        }
        if (installType === 'Self' && getAPPID() === 'AAL') {
          const response = yield call(Actions.updateISPUContactInfo, data, homePhoneAdded);
          if (response && response.data) {
            yield put({ type: 'IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS', response: response.data });
            if (
              response.data.serviceHeader &&
              ((response.data.serviceHeader.statusMsg && response.data.serviceHeader.statusMsg === 'SUCCESS') ||
                (response.data.serviceHeader.statusCode && response.data.serviceHeader.statusCode === '00'))
            ) {
              yield put({ type: 'UPDATE_CONTACT_SUCCESS', response: response.data });
              yield put({ type: Constants.CONTACT_INFO_EDIT_RESPONSE, data: 'success' });
              if (isFuncComp() || isExpressCheckout()) {
                yield put({
                  type: 'GET_CHECKOUT_DETAILS',
                  data: { paymentOptions: true, cart: true, shippingOptions: cartContactInfoIntg() || isPreorder() },
                });
              }
            }
          }
        }
        if (isSequentialFlow() && creditCheckRequest) {
          let isSuccess = true;
          // handle PIE encryption
          const encSSNNumber = yield call(pieProtectSPI, creditCheckRequest.ssn, ENCRYPTION_INPUT.SSN);
          isSuccess = encSSNNumber?.encryptionStatus?.isSuccess;
          if (!isSuccess) {
            // encryption failed - unable to load encrypted pin info
            const errorMsg = CreditCheckConstants.DEFAULT_ERR_MSG;
            yield put(notificationActions.showErrorNotification(errorMsg));
            return;
          }
          const creditCheckData = { ...creditCheckRequest, ssn: encSSNNumber.encryptedData };
          // to Trigger the initiate-creditcheck call after the updatePersonalInfo and updateISPU
          yield put({ type: 'CREDIT_CHECK_DATA', response: creditCheckData });
          let creditCheckApiError = false;
          let invalidCaseError = false;
          let serviceDetails = null;
          yield put({ type: 'CREDIT_CHECK_API_FAIL', response: creditCheckApiError });
          yield put({ type: CreditCheckConstants.CC_INVALIDCASE_ERROR, response: invalidCaseError });
          yield put({ type: CreditCheckConstants.CEF_CREDIT_CHECK_ERROR, response: creditCheckApiError, errorMessage: null });
          yield put(CreditCheckActions.creditCheckFailReload());
          const apiResponse = yield call(CreditCheckActions.runCreditReview, creditCheckData);
          showLoader();
          if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
            if (
              apiResponse.data.serviceHeader &&
              ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
                (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
            ) {
              yield put({ type: CreditCheckConstants.RUN_CREDIT_REVIEW_SUCCESS, response: true });
              yield put({ type: CreditCheckConstants.RUN_CREDIT_REVIEW_SUCCESS_DATA, response: true });
              yield put({ type: 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE', response: apiResponse.data.serviceBody });
              yield put({ type: 'RUN_CREDIT_DOWNPAYMENT_SUCCESS_RESPONSE', response: apiResponse.data.serviceBody });
              hideLoader();
            }
            yield put({ type: CreditCheckConstants.INITIATE_CREDIT_FAILED, response: '' });
          } else {
            if (apiResponse.data.errors[0]?.message === 'Looks like the address you entered is invalid.') {
              yield put({ type: 'INITIATE_CREDIT_FAILED_ADDRESS', response: true });
            }
            if (apiResponse?.data?.errors) {
              if (apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
                invalidCaseError = true;
                yield put({
                  type: CreditCheckConstants.CEF_CREDIT_CHECK_ERROR,
                  response: true,
                  errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
                });
              } else {
                creditCheckApiError = true;
                yield put({
                  type: CreditCheckConstants.CEF_CREDIT_CHECK_ERROR,
                  response: true,
                  errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
                });
              }

              if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `runCreditReview ${apiResponse?.data?.loggerData.note}`;
              logger(apiResponse?.data?.loggerData);

              serviceDetails = getServiceUrlandE2eRequestId('runCreditReview', apiResponse);
              yield put({ type: 'CREDIT_CHECK_API_FAIL', response: creditCheckApiError, serviceinfo: serviceDetails });
              yield put({ type: CreditCheckConstants.CC_INVALIDCASE_ERROR, response: invalidCaseError });
              hideLoader();
            }
            yield put({ type: CreditCheckConstants.INITIATE_CREDIT_FAILED, response: apiResponse.data.errors });
          }
        }
        // if (!isFuncComp()) {
        //   yield call(cartActions.getCartDetails, { pageName: data });
        // } else
        // if (isFuncComp() || isExpressCheckout()) {
        //   yield put({
        //     type: 'GET_CHECKOUT_DETAILS',
        //     data: { paymentOptions: true, cart: true, shippingOptions: cartContactInfoIntg() || isPreorder() },
        //   });
        // }
        // console.log('expressCheckout', isExpressCheckout());
        if (isExpressCheckout()) {
          yield put({
            type: actionTypes.GET_EXPRESS_CHECKOUT_DETAILS,
            data: { paymentOptions: true, cart: true, shippingOptions: true, customerAgreements: true },
            isCassNeeded: true,
          });
        }
        hideLoader();
      }
    } else {
      if (apiResponse && apiResponse?.status === 400 && apiResponse.data.errors) {
        if (checkInvalidCaseCartError(apiResponse?.data?.errors)) {
          contactInfoInvalidCaseError = true;
          yield put({
            type: Constants.CEF_CONTACT_INFO_ERROR,
            response: contactInfoInvalidCaseError,
            errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
          });
        }
      } else if (apiResponse.data.errors || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
        updatePersonalError = true;
        yield put({
          type: Constants.CEF_CONTACT_INFO_ERROR,
          response: updatePersonalError,
          errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
        });
      }
      serviceDetails = {
        serviceUrl: apiResponse?.config?.url,
        method: 'postNSEContactInfoData',
        e2eid: apiResponse?.headers?.e2erequestid,
      };
      if (apiResponse?.data?.errors || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `postContactInfo ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        hideLoader();
      }
      yield put({ type: Constants.CONTACT_INFO_EDIT_RESPONSE, data: 'failed' });
      if (apiResponse.data.errors[0] && apiResponse.data.errors[0].name === 'ADDRESS_VALIDATION_ERROR') {
        yield put({ type: 'BILLING_ADDRESS1_ERROR', response: true });
      }
      const notifyErrorMessage =
        apiResponse.data.errors[0] && apiResponse.data.errors[0].message
          ? apiResponse.data.errors[0].message
          : 'Looks like something went wrong. Please try again later.';
      if (notifyErrorMessage !== '') {
        yield put({ type: Constants.CONTACT_INFO_EDIT_ERROR, data: notifyErrorMessage });
      }
      yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CI_INVALID_CASE_ERROR, response: contactInfoInvalidCaseError, serviceinfo: serviceDetails });
    }
  } catch (error) {
    if (error) {
      updatePersonalError = true;
      serviceDetails = {
        method: 'postNSEContactInfoData',
      };
      yield put({ type: 'UPDATE_PERSONAL_API_FAIL', response: updatePersonalError, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: updatePersonalError, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
    yield put({ type: Constants.ERR_OCCURED });
  }
}
function* postContactInfoISPUUpdate({ data, homePhoneAdded }) {
  try {
    showLoader();
    const response = yield call(Actions.updateISPUContactInfoForExpressCheckout, data, homePhoneAdded, true);
    if (response && response.data) {
      yield put({ type: 'IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS', response: response.data });
      if (
        response.data.serviceHeader &&
        ((response.data.serviceHeader && response.data?.serviceHeader?.statusMsg === 'SUCCESS') ||
          (response.data.serviceHeader.statusCode && response?.data?.serviceHeader?.statusCode === '00'))
      ) {
        // Calling GET CHECKOUT API ON SUCCESS OF UPDATE ISPU CONTACT INFO
        yield put({
          type: actionTypes.GET_EXPRESS_CHECKOUT_DETAILS,
          data: { paymentOptions: true, cart: true, shippingOptions: true, customerAgreements: true },
          isCassNeeded: true,
        });
        yield put({ type: 'UPDATE_CONTACT_SUCCESS', response: response.data });
        yield put({ type: Constants.CONTACT_INFO_EDIT_RESPONSE, data: 'success' });
      }
    } else {
      yield put({ type: Constants.CONTACT_INFO_EDIT_RESPONSE, data: 'failed' });
    }
    hideLoader();
  } catch (error) {
    if (error) {
      hideLoader();
    }
    yield put({ type: Constants.ERR_OCCURED });
  }
}
function* updateISPUContactInfoData({ data }) {
  showLoader();
  try {
    const response = yield call(Actions.updateISPUContactInfo, data);
    if (response && response.data) {
      if (
        response.data.serviceHeader &&
        ((response.data.serviceHeader.statusMsg && response.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (response.data.serviceHeader.statusCode && response.data.serviceHeader.statusCode === '00'))
      ) {
        yield put({ type: 'UPDATE_CONTACT_SUCCESS', response: response.data });
        hideLoader();
      }
      hideLoader();
    } else {
      hideLoader();
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    hideLoader();
  }
}

function* getZipCodeDetails(zipCode) {
  yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: false, errorMessage: null });
  try {
    const apiResponse = yield call(Actions.getZipCodeDetailsAPI, zipCode);
    if (apiResponse && apiResponse.data && apiResponse.data.marketDetails && !apiResponse.data.errors) {
      yield put({ type: 'CITY_AND_STATE_SUCCESS', response: apiResponse.data });
    } else if ((apiResponse.data.errors && apiResponse.data.errors.length > 0) || apiResponse?.data?.serviceHeader?.statusCode !== '00') {
      yield put({ type: 'INVALID_ZIP_CODE', isInvalidZipcodeError: true });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });

      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getZipCodeDetails ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
    yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });

    hideLoader();
  }
}

function* showCart(value) {
  yield put({ type: Constants.UPDATE_SHOW_CART, data: value.data });
}

function* updateSuccessFlag() {
  yield put({ type: Constants.IS_UPDATE_INFO_SUCCESS, response: false });
}

function* updateIspuContactInfoSuccessFlag() {
  yield put({ type: Constants.IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS, response: false });
}

function* emailValidation({ data }) {
  try {
    showLoader();
    const isCradleFlow = getSession('skipReg') === 'Y' || store.getState()?.contactInfo?.isCradleSuccess;
    const apiResponse = yield call(Actions.emailValidationAPI, { ...data, isCradleFlow });
    if (apiResponse && apiResponse.data) {
      if (apiResponse.data.maxAttempts && apiResponse.data.valid === 'false') {
        yield put({ type: 'EMAIL_MAX_ATTEMPTS', response: true });
      } else if (apiResponse.data.valid === 'Manual_validation') {
        apiResponse.data.accMainEmailVal = { success: false };
      }
      hideLoader();
      yield put({ type: 'EMAIL_VALIDATION', response: apiResponse.data });

      if (data.isUniversalProfileCreated) {
        yield put({ type: 'CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE' });
      }

      const validationStatus = apiResponse.data.valid;
      if (validationStatus === 'true' || validationStatus === 'Valid' || validationStatus === 'White_listed') {
        yield put({ type: Constants.LATEST_SUCCESSFULLY_VERIFIED_EMAIL, payload: data.email });
      }
    } else {
      logError('error occured in emailValidation');
    }
  } catch (error) {
    hideLoader();
  }
}

function* phoneValidation({ data }) {
  try {
    showLoader();
    const isCradleFlow = getSession('skipReg') === 'Y' || store.getState()?.contactInfo?.isCradleSuccess;
    const apiResponse = yield call(Actions.phoneValidationAPI, { ...data, isCradleFlow });
    if (apiResponse && apiResponse.data) {
      if (apiResponse?.data?.maxAttempts && apiResponse?.data?.valid === 'false') {
        yield put({ type: 'EMAIL_MAX_ATTEMPTS', response: true });
      } else if (apiResponse.data.valid === 'Manual_validation') {
        apiResponse.data.accMainEmailVal = { success: false };
      }
      hideLoader();
      yield put({ type: 'PHONE_VALIDATION', response: apiResponse.data });

      if (data.isUniversalProfileCreated) {
        yield put({ type: 'CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE' });
      }
    } else {
      logError('error occured in emailValidation');
    }
  } catch (error) {
    hideLoader();
  }
}

function* accMaintenenceEmailValidation(data) {
  try {
    const apiResponse = yield call(Actions.accMainEmailValidation, data);
    if (apiResponse && apiResponse.data && apiResponse.data.error !== null) {
      if (apiResponse?.data?.data === null) {
        yield put({ type: 'EMAIL_VALIDATION', response: { valid: 'true' } });
      } else {
        yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: false } });
      }
    } else if (apiResponse && apiResponse.data && apiResponse.data.error === null) {
      yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: true } });
    }
  } catch (error) {
    logError('error');
    hideLoader();
  }
}

function* postShippingoptionFromContact({ selectedShipping, selectedslots, sddOption, homePhoneAdded }) {
  yield put(Actions.buildShippingOptionsContactInput(selectedShipping, selectedslots, sddOption, homePhoneAdded));
}

function* contactGetEnabledDevices({ data }) {
  let errorShipping = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: null });
  showLoader();
  try {
    const apiResponse = yield call(ShippingActions.fetchDevices, data);

    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({
        type: Constants.CONTACT_FETCH_SMS_DEVICES_SUCCESS,
        response: {
          fetchSMSEnabledDevices: apiResponse.data.devices,
        },
        commonData: {
          securePinVerifyFormVisible: false,
          sendSMS: false,
          fetchSMSEnabledDevices: true,
        },
      });
      hideLoader();
      yield put({ type: Constants.CONTACT_GET_DATA_SUCCESS, response: apiResponse.data });
      yield put({ type: Constants.CONTACT_GET_ENABLED_DEVICES_SUCCESS, response: apiResponse.data });
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorShipping = true;

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getEnabledDevices ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      yield put({ type: Constants.ERR_OCCURED, errorShipping });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* contactUpdateShippingOptionsData(data) {
  let errorShipping = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: null });
  const notifyErrorMessage = data?.selectedShipping?.notifyMessage;

  showLoader();
  yield put(notificationActions.hideNotification());
  try {
    const apiResponse = yield call(
      ShippingActions.updateShippingOptions,
      data.selectedShipping,
      data.selectedslots,
      data.sddOption,
      data.homePhoneAdded,
    );
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      if (
        apiResponse.data.serviceHeader &&
        ((apiResponse.data.serviceHeader.statusMsg && apiResponse.data.serviceHeader.statusMsg === 'SUCCESS') ||
          (apiResponse.data.serviceHeader.statusCode && apiResponse.data.serviceHeader.statusCode === '00'))
      ) {
        yield call(cartActions.getCartDetails, { pageName: data });
        yield put({ type: Constants.POST_SHIPPING_OPTION_SUCCESS, response: apiResponse.data });
        hideLoader();
      } else {
        console.log('');
        hideLoader();
      }
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorShipping = true;

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateShippingOptionsData ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      yield put({ type: Constants.ERR_OCCURED, errorShipping });
      yield put({ type: Constants.CEF_CONTACT_INFO_ERROR, response: errorShipping, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    if (error) {
      hideLoader();
    }
  }
}

function* createUniversalProfile(data) {
  try {
    const status = data?.status;

    if (status === 'Success') {
      yield put({ type: Constants.CREATE_UNIVERSAL_PROFILE_SUCCESS });
    } else {
      yield put({ type: Constants.CREATE_UNIVERSAL_PROFILE_FAILURE });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: Constants.CREATE_UNIVERSAL_PROFILE_FAILURE });
  }
}

function* callCradleApi() {
  try {
    showLoader();
    const skipReg = getSession('skipReg') === 'Y';
    if (skipReg) {
      yield put({ type: Constants.STORE_CRADLE_RESPONSE, payload: true });
    }
    const response = yield call(Actions.postCradleApi);
    yield put({ type: Constants.STORE_CRADLE_THROTTLE_LIST, payload: response?.data?.throttleList });
    if (response?.data?.throttleList.includes(Constants.CRADLE_SUCCESS)) {
      yield put({ type: Constants.STORE_CRADLE_RESPONSE, payload: true });
    }
  } catch (error) {
    console.log(error);
  } finally {
    hideLoader();
  }
}

function* hardToGuessPassword(data) {
  try {
    const payloadData = {
      pwdToken: btoa(data.value),
    };
    const response = yield call(Actions.hardToGuessPasswordApi, payloadData);
    if (response?.data) {
      yield put({
        type: Constants.STORE_BLACK_LISTED_DETAILS,
        payload: response?.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_CONTACT_INFO_FROM_API, getContactInfoFromApi);
  yield takeLatest(Constants.SHOW_CART, showCart);
  yield takeLatest(Constants.POST_DATA, postContactInfo);
  yield takeLatest('POST_NSE_DATA', postNSEContactInfoData);
  yield takeLatest(Constants.UPDATE_SUCCESS_FLAG, updateSuccessFlag);
  yield takeLatest(Constants.UPDATE_ISPU_CONTACT_INFO_SUCCESS_FLAG, updateIspuContactInfoSuccessFlag);
  yield takeLatest(Constants.GET_ZIPCODE_DETAILS, getZipCodeDetails);
  yield takeLatest(Constants.UPDATE_ISPU_CONTACT_INFO, updateISPUContactInfoData);
  yield takeLatest(Constants.EMAIL_VALIDATION_FROM_API, emailValidation);
  yield takeLatest(Constants.PHONE_VALIDATION_FROM_API, phoneValidation);
  yield takeLatest(Constants.GET_CONT_INFO_ON_CLICK, getContactInfoOnClick);
  yield takeLatest('POST_SHIPPING_OPTION_FROM_CONTACT', postShippingoptionFromContact);
  yield takeLatest(Constants.CONTACT_GET_ENABLED_DEVICES, contactGetEnabledDevices);
  yield takeLatest(Constants.CONTACT_POST_SHIPPING_OPTION, contactUpdateShippingOptionsData);
  yield takeLatest(Constants.ACCOUNT_MAINTENENCE_EMAIL_VERIFICATION, accMaintenenceEmailValidation);
  yield takeLatest(Constants.CALL_CRADLE_API, callCradleApi);
  yield takeLatest(Constants.HARD_TO_GUESS_API, hardToGuessPassword);
  yield takeLatest('ISPU_CONTACTINFO_UPDATE_EXPRESSCHECKOUT', postContactInfoISPUUpdate);
  // ISPU_CONTACTINFO_UPDATE_EXPRESSCHECKOUT
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
